const RelationalModel = require('../extensions/relational-model.js');
const RelationalCollection = require('../extensions/relational-collection.js');
const parameters = require('./parameters.js');

const Club = RelationalModel.extend({
  // nothing
});

const ClubCollection = RelationalCollection.extend({
  model: Club,
  url() {
    return `${parameters.get('api_base_url')}/${parameters.get('client_token')}/clubs`;
  }
});

module.exports = new ClubCollection();

// declare parse method after module export to avoid cyclic dependency
Club.prototype.parse = function(response) {
  const self = this;

  const activities = require('./activities.js');
  response.activities = activities.extend(activities.merge(response.activities, { parse: true }), {
    fetchUrl() {
      return `${self.url()}/activities`;
    }
  });

  const activitygroups = require('./activitygroups.js');
  response.activitygroups = activitygroups.extend(activitygroups.merge(response.activitygroups, { parse: true }), {
    fetchUrl() {
      return `${self.url()}/activitygroups`;
    }
  });

  const bookings = require('./bookings.js');
  response.bookings = bookings.extend(bookings.merge(response.bookings, { parse: true }), {
    fetchUrl() {
      return `${self.url()}/bookings`;
    }
  });

  const studios = require('./studios.js');
  response.studios = studios.extend(studios.merge(response.studios, { parse: true }), {
    fetchUrl() {
      return `${self.url()}/studios`;
    }
  });

  const coaches = require('./coaches.js');
  response.coaches = coaches.extend(coaches.merge(response.coaches, { parse: true }), {
    fetchUrl() {
      return `${self.url()}/coachs`;
    }
  });

  return response;
};



// WEBPACK FOOTER //
// ./src/data/clubs.js